import { createEffect, createSignal } from 'solid-js'

interface AccordionProps {
  heading: string
  para: string
  isExpanded?: boolean
}

export default function Accordion(props: AccordionProps) {
  const [height, setHeight] = createSignal(0)
  const [isOpen, setIsOpen] = createSignal(props.isExpanded || false)
  let ref: HTMLDivElement | undefined

  // Update isOpen when isExpanded prop changes
  createEffect(() => {
    setIsOpen(props.isExpanded || false)
  })

  createEffect(() => {
    if (ref) {
      // Force a recalculation of height when content changes
      const newHeight = ref.scrollHeight
      setHeight(isOpen() ? newHeight : 0)
    }
  })

  return (
    <article class="accordion">
      <div class="wrap bg-light/[0.05] global-shadow rounded-xl">
        <header
          onClick={() => setIsOpen(!isOpen())}
          class="flex cursor-pointer items-center justify-between px-4 py-3"
        >
          <h3 class="text-base font-semibold">
            <div innerHTML={props.heading} />
          </h3>

          <div class="arrow ml-3 flex items-center justify-center">
            <div class="rounded-lg p-0.5">
              <img
                class={`min-height-[20px] min-w-[20px] text-2xl transition-all duration-300 ${
                  isOpen() ? 'rotate-180' : ''
                }`}
                src="/images/icons/arrow.svg"
                height={20}
                width={20}
                alt="arrow"
              />
            </div>
          </div>
        </header>

        <div
          style={{ 'max-height': `${height()}px` }}
          class={`faq-content overflow-hidden transition-all duration-300`}
        >
          <div ref={ref} class="wrapper">
            <div class="border-t border-primary/20 px-4 pb-5 pt-4 text-base font-normal leading-[25px]">
              <div class="collaps" innerHTML={props.para} />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
